<div class="container-fluid max-w-screen-lg vstack gap-6 mt-4">
    <div class="card">
        <div class="card-body">
            <div class="reminder mb-0 d-flex bg-light justify-content-between">
                <h5 class="card-title ps-4 mb-0 tableTitle">Integrations</h5>
                <div class="submitForm d-flex justify-content-center align-items-center">

                </div>
            </div>
            <div class="table-responsive">
                <table matSort class="table table-hover table-nowrap">
                    <thead class="table-light">
                        <tr>
                            <th mat-sort-header="message" scope="col" class="ps-4">Integration</th>

                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let integration of integrations; let i = index">
                            <td class="text-heading font-semibold">{{integration.provider}}</td>
                            <td>
                                <a class="btn btn-neutral btn-sm bt-square ms-1" (click)="onEdit(integration)"
                                    matTooltip="Edit Integration">
                                    <i class="bi bi-pencil-fill"></i>
                                </a>
                            </td>
                        </tr>
                </table>
            </div>
        </div>
    </div>
</div>